import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services/config';
import { ShipmentListSearchCriteria } from '../models/shipment.model';
import { ShipmentGlobalTrackingMapModel } from '../models/shipment-list/shipment-global-tracking-map.model';
import { ListViewMode } from '../../constants';
import { ShipmentEndpoint } from '../constants';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ShipmentGlobalTrackingMapService {
  constructor(private http: HttpClient) {}
  getShipmentMapData({
    size,
    page,
    viewMode: _viewMode,
    shipmentStatisticFilter,
    filters,
  }: ShipmentListSearchCriteria): Observable<ShipmentGlobalTrackingMapModel[]> {
    const url = `${API_URL}${ShipmentEndpoint.Base}${ShipmentEndpoint.Map}`;

    return this.http.post<ShipmentGlobalTrackingMapModel[]>(url, {
      viewMode: ListViewMode.Load,
      statisticFilter: shipmentStatisticFilter,
      size,
      page,
      filter: filters,
    });
  }
}
